// RenderImage.tsx
import React, { useState } from 'react';
import { Icon } from 'tea-component';
import './RenderImage.scss';
interface RenderImageProps {
  src: string;
  className?: string;
  alt?: string;
  defaultSrc?: string;
  haveLoading?: boolean;
  onLoad?: () => void;
  onError?: () => void;
}

const RenderImage: React.FC<RenderImageProps> = ({ src, className, alt = '', defaultSrc = '', haveLoading, onLoad, onError }) => {

  if (!src) return null;
  const [loading, setLoading] = useState(true);

  return (
    <span className='dba-img-box'>
      {
        loading && haveLoading && <Icon
          size="l"
          type="loading"
          className="dba-img-box-loading"
        />
      }
      <img
        className={className}
        src={src}
        alt={alt}
        onLoad={() => {
          setLoading(false);
          onLoad?.();
        }}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          if (defaultSrc) {
            target.src = defaultSrc;
          } else {
            target.style.display = 'none';
          }
          setLoading(false);
          onError?.();
        }}
      />
    </span>
  );
};

export default RenderImage;